import React from 'react';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';

type SummaryTileProps = {
    label: string;
    value: string;
    slot: string;
};

/** A single labelled figure in the cost/markup summary. */
export const SummaryTile: React.FC<SummaryTileProps> = ({
    label,
    value,
    slot,
}) => (
    <div
        className="flex flex-col gap-1"
        {...getNodeTestIdProp(`manual-import-summary-tile-${slot}`)}
    >
        <span className="text-xs text-muted">{label}</span>
        <span
            className="text-lg font-semibold text-foreground"
            {...getNodeTestIdProp(`manual-import-summary-${slot}`)}
        >
            {value}
        </span>
    </div>
);
